// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"bde8a60fbd914203","226":"15909f0c4c23ae0a","793":"42ef63b7ec463244","904":"8455690b3489576f","984":"0ce768c888aa01bd"}[chunkId] + ".js";
};